import axios from "axios"
import { 
  CONTRACT_SELECTED,
  CONTRACT_VARIANT_SELECTED,
  EDIT_CONTRACT_MODE,
  ADD_CONTRACT_MODE,
  DELETE_CONTRACT_MODE,
  GET_CONTRACTS,
  GET_RULES,
  CREATE_CONTRACT,
  MOD_CONTRACT,
  DELETE_CONTRACT,
  RESET_CONTRACT_SELECTED,
  RESET_CONTRACT_VARIANT_SELECTED,
  CLEAR_CONTRACTS,
  HANDLE_CONTRACTS_INPUTS
} from "redux/reducers/contractsCatalog/contractsCatalogReducer"
import { START_REQUEST_SEARCH, STOP_REQUEST_SEARCH, SET_SNACKBAR_SEARCH } from "redux/reducers/search/searchReducer";

export const getAllRules = ( token ) => {
  const url = `${process.env.REACT_APP_URL}/crm/contract_rules`
  const headers = { Authorization: token }
  let payload = {}
  return async( dispatch ) => {
    await axios.get(url, { headers }).then(resp => {
      payload = {
        type: GET_RULES,
        payload: resp.data
      }
      dispatch(payload)
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}


export const getAllContracts = ( token ) => {
  const url = `${process.env.REACT_APP_URL}/crm/contracts/with_variants`
  const headers = { Authorization: token }
  let payload = {}
  return async( dispatch ) => {
    await axios.get(url, { headers }).then(resp => {
      payload = {
        type: GET_CONTRACTS,
        payload: resp.data
      }
      dispatch(payload)
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const getContracts = ( token, stationID ) => {
  const url = `${process.env.REACT_APP_URL}/crm/contracts/with_variants/by_station/${stationID}`
  const headers = { Authorization: token }
  let payload = {}
  return async( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.get(url, { headers }).then(resp => {
      payload = {
        type: GET_CONTRACTS,
        payload: resp.data.map(contract => ({...contract, value: contract.id}))
      }
      dispatch(payload)
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const changeContractSelected = (id) => {
  return {
    type: CONTRACT_SELECTED,
    payload: id
  }
}

export const changeContractVariantSelected = (id) => {
  return {
    type: CONTRACT_VARIANT_SELECTED,
    payload: id
  }
}

export const addContractMode = () => {
  return {
    type: ADD_CONTRACT_MODE,
  }
}

export const editContractMode = () => {
  return {
    type: EDIT_CONTRACT_MODE,
  }
}

export const deleteContractMode = () => {
  return {
    type: DELETE_CONTRACT_MODE,
  }
}

export const resetContractSelected = () => {
  return {
    type: RESET_CONTRACT_SELECTED
  }
}

export const resetContractVariantSelected = () => {
  return {
    type: RESET_CONTRACT_VARIANT_SELECTED
  }
}

export const createNewContract = (form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/contracts`
  const headers = { Authorization: token }
  let payload = {}
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.post(url, form, { headers }).then(resp => {
      payload = {
        type: CREATE_CONTRACT,
        payload: resp.data
      }
      dispatch(payload)
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'El contrato se ha creado con éxito.', color: 'success' }
      })
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const editContract = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/contracts/${id}`
  const headers = { Authorization: token } 
  let payload = {}
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.put(url, form, { headers }).then(resp => {
      payload = {
        type: MOD_CONTRACT,
        payload: resp.data
      }
      dispatch(payload)
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'El contrato se ha modificado con éxito.', color: 'success' }
      })
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const deleteContract = (id, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/contracts/${id}`
  const headers = { Authorization: token }
  let payload = {}
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH })

    await axios.delete(url, { headers }).then(resp => {
      payload = {
        type: DELETE_CONTRACT,
        payload: resp.data.id
      }
      dispatch(payload)
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'El contrato se ha eliminado con éxito.', color: 'success' }
      })
    }).catch(error => {
      const err = error.response.data?.message.error
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      })
    })
    dispatch({ type: STOP_REQUEST_SEARCH })
  }
}

export const clearContracts = () => {
  return {
    type: CLEAR_CONTRACTS,
  }
}

export const handleContractsInputsAction = (key, value) => dispatch => {
  dispatch({ type: HANDLE_CONTRACTS_INPUTS, payload: { key, value } });
}